/**
 * @type {boolean}
 */
const isBrowser = typeof window !== 'undefined'

module.exports = isBrowser
